import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/drikkevelger.tsx';
defineClientComponent('drikkevelger', Component);